import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { FC, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Company } from "src/apis/company";
import NoDataAlert from "src/pages/components/NoDataAlert";

type CompaniesTableProps = {
  companies: Company[];
};

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);

const CompaniesTable: FC<CompaniesTableProps> = ({ companies }): JSX.Element => {
  const navigate = useNavigate();
  const hasCompanies = useMemo(() => Boolean(companies) && companies.length > 0, [companies]);

  return hasCompanies ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>ID</strong></TableCell>
            <TableCell><strong>Nome fantasia</strong></TableCell>
            <TableCell><strong>Tipo de Documento</strong></TableCell>
            <TableCell><strong>Número de Documento</strong></TableCell>
            <TableCell><strong>Responsável legal</strong></TableCell>
            <TableCell><strong>Tipo de assinatura</strong></TableCell>
            <TableCell><strong>Colaboradores</strong></TableCell>
            <TableCell><strong>Consultas Pagas</strong></TableCell>
            <TableCell><strong>Coparticipações</strong></TableCell>
            <TableCell><strong>Ações</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {companies?.map((company: Company) => (
            <TableRow key={company.id}>
              <TableCell>{company.id}</TableCell>
              <TableCell>{company.trade_name}</TableCell>
              <TableCell>
                {Boolean(company?.document_type) && <Chip label={company.document_type} />}
              </TableCell>
              <TableCell>{company.document}</TableCell>
              <TableCell>{company.responsible}</TableCell>
              <TableCell><Chip label={company.subscription} /></TableCell>
              <TableCell><Chip label={company.collaborator_quantity} /></TableCell>
              <TableCell><Chip label={company?.consultas_pagas ?? 0} /></TableCell>
              <TableCell><Chip label={company?.coparticipativas ?? 0} /></TableCell>
              <TableCell>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Tooltip title="Editar">
                    <IconButton
                      size="small"
                      onClick={() => navigate(`/empresa/${company.id}/editar`)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  {(company.mensalidade ?? 0) > 0 && (
                    <Tooltip
                      title={formatCurrency(company.mensalidade ?? 0)}
                      arrow
                    >
                      <IconButton size="small" disableRipple sx={{ cursor: "default" }}>
                        <AttachMoneyIcon
                          fontSize="small"
                          color={company.mensalidade_quitada ? "success" : "warning"}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoDataAlert />
  );
};

export default CompaniesTable;
